export default "<app-header\n  (languagePicked)=\"useLanguage($event)\">\n</app-header>\n<main>\n  <router-outlet></router-outlet>\n</main>\n"